export default __webpack_public_path__ + "static/media/slack.4c58d324.svg";